import { useLayoutContext } from '@/container/context/layout/layout-context';
import { useAssignChannels } from '@modules/channels/hooks/use-sidebar-assign-channels';
import { useWorkspaceMembers } from '@modules/members/hooks/use-sidebar-members';
import { useTeams } from '@modules/teams/hooks/use-sidebar-teams';

export function useSidebarHooks() {
  const layoutContext = useLayoutContext();
  const assignChannels = useAssignChannels();
  const workspaceMembers = useWorkspaceMembers();
  const teams = useTeams();

  return {
    assignChannels,
    layoutContext,
    teams,
    workspaceMembers,
  };
}
